import React, { Component } from 'react'
import classNames from 'classnames'

export default class NativeSelect extends Component {
  state = {
    isFocused: false,
  }

  render() {
    const { disabled, valid, error, className, style, ...props } = this.props
    const { isFocused } = this.state

    const _className = classNames(
      'slite-select',
      [
        'margin-vertical-small padding-horizontal-medium padding-vertical-normal',
        'font-size-small black background-shade-100',
        'border-small radius-normal',
        'flexbox-grow',
      ],
      {
        'border-shade-40': !isFocused && !valid && !error,
        'border-shade-30': isFocused && !valid && !error,
        'border-green': valid,
        'border-red': error,
        'cursor-forbidden background-stripped-shade-100': disabled,
      },
      className
    )

    return (
      <select
        className={_className}
        disabled={disabled}
        onFocus={this.onFocus}
        onBlur={this.onBlur}
        {...props}
      >
        {this.props.children}
      </select>
    )
  }

  onFocus = e => {
    this.setState(state => ({
      isFocused: true,
    }))
    this.props.onFocus && this.props.onFocus(e)
  }

  onBlur = e => {
    this.setState(state => ({
      isFocused: false,
    }))
    this.props.onBlur && this.props.onBlur(e)
  }
}
